import { render, staticRenderFns } from "./BaseImageSearchPreview.vue?vue&type=template&id=3012f133&"
import script from "./BaseImageSearchPreview.vue?vue&type=script&lang=js&"
export * from "./BaseImageSearchPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/lucia/proyectos/byl_salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3012f133')) {
      api.createRecord('3012f133', component.options)
    } else {
      api.reload('3012f133', component.options)
    }
    module.hot.accept("./BaseImageSearchPreview.vue?vue&type=template&id=3012f133&", function () {
      api.rerender('3012f133', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseImageSearchPreview.vue"
export default component.exports